// Tema MUI v5 do TeraBlues. Os valores vêm de ./tokens (gerado de design-system/tokens/tokens.json).
// Uso: <ThemeProvider theme={criarTemaTeraBlues('light')}> ... </ThemeProvider>
import { createTheme } from '@mui/material/styles';
import tokensTeraBlues from './tokens';

const paraPixels = (valor) => parseInt(valor, 10);

// Texto do chip de aviso (outlined) no tema claro: o laranja padrão do MUI (#ed6c02) tem só 3,1:1 sobre branco e reprova no contraste AA (4,5:1,
// axe "color-contrast"); este tem 5,5:1. A borda segue no laranja padrão (contraste de componente exige 3:1).
export const TEXTO_AVISO_CLARO = '#b34700';

export function criarTemaTeraBlues(modo = 'light') {
  const cor = tokensTeraBlues.cores[modo];
  const estilo = tokensTeraBlues.textos;

  return createTheme({
    palette: {
      mode: modo,
      primary: { main: cor['primaria'], dark: cor['primaria-hover'], contrastText: cor['sobre-primaria'] },
      error: { main: cor['perigo'] },
      background: { default: cor['superficie'], paper: cor['superficie'] },
      text: { primary: cor['texto'], secondary: cor['texto-suave'] },
      divider: cor['borda'],
    },
    shape: { borderRadius: paraPixels(tokensTeraBlues.raio['raio-sm']) },
    typography: {
      fontFamily: tokensTeraBlues.fontes.sans,
      h1: { fontSize: estilo['display'].fontSize, lineHeight: estilo['display'].lineHeight, fontWeight: 600 },
      h2: { fontSize: estilo['titulo-1'].fontSize, lineHeight: estilo['titulo-1'].lineHeight, fontWeight: 600 },
      h3: { fontSize: estilo['titulo-2'].fontSize, lineHeight: estilo['titulo-2'].lineHeight, fontWeight: 600 },
    },
    components: {
      MuiAppBar: {
        styleOverrides: { root: { backgroundColor: cor['barra-fundo'], color: cor['barra-texto'], boxShadow: 'none' } },
      },
      MuiChip: {
        styleOverrides: {
          root: ({ ownerState }) => (modo === 'light' && ownerState.variant === 'outlined' && ownerState.color === 'warning' ? { color: TEXTO_AVISO_CLARO } : {}),
        },
      },
      MuiButton: { defaultProps: { disableElevation: true } },
      MuiOutlinedInput: {
        styleOverrides: { root: { '& .MuiOutlinedInput-notchedOutline': { borderColor: cor['borda-controle'] } } },
      },
      MuiCard: {
        defaultProps: { variant: 'outlined' },
        styleOverrides: { root: { borderRadius: paraPixels(tokensTeraBlues.raio['raio-lg']), borderColor: cor['borda'], boxShadow: 'none' } },
      },
    },
  });
}

export default criarTemaTeraBlues;
